import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Suspense as _Suspense, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c8e44c28"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container-fluid p-0 m-0 mb-4 mt-1" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "mb-0" }, null, -1))
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col" }
const _hoisted_5 = {
  key: 0,
  class: "miners__container row px-3 mt-4"
}
const _hoisted_6 = {
  key: 1,
  class: "miners_table_container row px-3 mt-4"
}
const _hoisted_7 = {
  class: "miners__table",
  style: {"padding-top":"10px","padding-bottom":"10px"}
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Model", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Cena", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Kopie w ciągu doby", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Koszt prądu w ciągu doby", -1))
const _hoisted_12 = { key: 0 }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Zysk na czysto", -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Zwrot w ciagu", -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Link do produktu", -1))

import { useStore } from "vuex";
import { computed, ref, watch } from "vue";
import koparkaWynik from "./koparkaWynik.vue";
import koparkaWynikTable from "./koparkaWynikTable.vue";
import koparkaWynikSkelet from "../components/skelets/koparkaWynikSkelet.vue";
import tabelaKoparek_filtry from "./tabelaKoparek_filtry.vue";

interface Miner {
  id: number;
  isAsic: boolean;
  name: string;
  link: string;
  power: number;
  algorithm: string;
  price: number;
  img: string;
  hashrate: number;
  units: string;
  revenue: number;
  profits: {
    profit: number;
    powerCost: number;
    daysToReachCost: number;
    heatProfit: number;
  };
}


export default /*#__PURE__*/_defineComponent({
  __name: 'tabelaKoparek',
  setup(__props) {

const store = useStore();

const list = computed(() => {
  return store.getters["miners/getList"];
});
const withHeat = computed(() => {
  return store.getters["miners/getMinersType"];
});
const miners = computed(() => {
  const miners = [...store.getters["miners/getMiners"]];
  const advancedFilter = store.getters["miners/getAdvancedFilter"];
  if (advancedFilter === "fastestReturn") {
    return miners.sort(
      (miner1, miner2) =>
        getDaysToReachCost(miner1) - getDaysToReachCost(miner2)
    );
  } else if (advancedFilter === "chippest") {
    return miners.sort((miner1, miner2) => miner1.price - miner2.price);
  } else if (advancedFilter === "expensive") {
    return miners.sort((miner1, miner2) => miner2.price - miner1.price);
  } else {
    return miners.sort(
      (miner1, miner2) => getProfit(miner2) - getProfit(miner1)
    );
  }
});
const filterMinersByAlgorithm = function (miner: Miner) {
  const filters = store.getters["miners/getAlgorithmsFilter"];
  return filters.some((filter: string) => miner.algorithm === filter);
};

const getDaysToReachCost = (miner: Miner) => {
  return miner.profits && miner.profits.daysToReachCost
    ? miner.profits.daysToReachCost
    : Number.MAX_SAFE_INTEGER;
};

const getProfit = (miner: Miner) => {
  return miner.profits && miner.profits.profit ? miner.profits.profit : 0;
};

const checkProfitable = function (miner: Miner) {
  const onlyProfitable = store.getters["miners/getProfitable"];
  if (miner.profits.profit < 1 && onlyProfitable) {
    return false;
  } else {
    return true;
  }
};

const filteredMiners = computed(() => {
  return miners.value.filter((miner) => {
    return (
      !Number.isNaN(miner.revenue) &&
      miner.revenue !== undefined &&
      checkProfitable(miner) &&
      filterMinersByAlgorithm(miner)
    );
  });
});
const counter = computed(() => filteredMiners.value.length);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createVNode(tabelaKoparek_filtry, { counter: counter.value }, null, 8, ["counter"])
      ])
    ]),
    (!list.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(miners.value, (miner, index) => {
            return (_openBlock(), _createBlock(_Suspense, { key: index }, {
              default: _withCtx(() => [
                (
              !Number.isNaN(miner.revenue) &&
              miner.revenue !== undefined &&
              checkProfitable(miner) &&
              filterMinersByAlgorithm(miner)
            )
                  ? (_openBlock(), _createBlock(koparkaWynik, {
                      key: 0,
                      id: index + 1,
                      name: miner.name,
                      link: miner.link,
                      power: miner.power,
                      algorithm: miner.algorithm,
                      price: miner.price,
                      img: miner.img,
                      hashrate: miner.hashrate,
                      units: miner.units,
                      revenue: miner.revenue,
                      profit: miner.profits.profit,
                      powerCost: miner.profits.powerCost,
                      daysToReachCost: miner.profits.daysToReachCost,
                      heatProfit: miner.profits.heatProfit
                    }, null, 8, ["id", "name", "link", "power", "algorithm", "price", "img", "hashrate", "units", "revenue", "profit", "powerCost", "daysToReachCost", "heatProfit"]))
                  : _createCommentVNode("", true)
              ]),
              fallback: _withCtx(() => [
                _createVNode(koparkaWynikSkelet)
              ]),
              _: 2
            }, 1024))
          }), 128))
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _createElementVNode("table", _hoisted_7, [
            _createElementVNode("thead", null, [
              _hoisted_8,
              _hoisted_9,
              _hoisted_10,
              _hoisted_11,
              (withHeat.value)
                ? (_openBlock(), _createElementBlock("th", _hoisted_12, "Wytwarza ciepła za"))
                : _createCommentVNode("", true),
              _hoisted_13,
              _hoisted_14,
              _hoisted_15
            ]),
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(miners.value, (miner, index) => {
                return (_openBlock(), _createBlock(_Suspense, { key: index }, {
                  default: _withCtx(() => [
                    (
                !Number.isNaN(miner.revenue) &&
                miner.revenue !== undefined &&
                checkProfitable(miner) &&
                filterMinersByAlgorithm(miner)
              )
                      ? (_openBlock(), _createBlock(koparkaWynikTable, {
                          key: 0,
                          id: index + 1,
                          name: miner.name,
                          link: miner.link,
                          power: miner.power,
                          algorithm: miner.algorithm,
                          price: miner.price,
                          img: miner.img,
                          hashrate: miner.hashrate,
                          units: miner.units,
                          revenue: miner.revenue,
                          profit: miner.profits.profit,
                          powerCost: miner.profits.powerCost,
                          daysToReachCost: miner.profits.daysToReachCost,
                          heatProfit: miner.profits.heatProfit
                        }, null, 8, ["id", "name", "link", "power", "algorithm", "price", "img", "hashrate", "units", "revenue", "profit", "powerCost", "daysToReachCost", "heatProfit"]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 2
                }, 1024))
              }), 128))
            ])
          ])
        ]))
  ]))
}
}

})